'use strict';

// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';
// Import JSX Modules
import Select from '../_utils/select-wrapper';
import CalendarDates from './calendar-dates';

export default class CalendarStartDateSelector extends React.Component {
  constructor(props) {
    super(props);
    this.monthOptions = CalendarDates.getOptions();
    this.handleChange = this.handleChange.bind(this);
  }
  render() {
    const selectedOption =
      this.monthOptions.find((mO) => mO.value === this.props.value) ||
      CalendarDates.getDefaultValue();

    return (
      <div className="filter">
        <div className="title-and-value">
          {this.props.isClient && (
            <>
              <label htmlFor="startingMonthSelect">
                <strong className="title">Starting Month:</strong>
              </label>
              <span aria-hidden="true" className="value">
                {selectedOption.label}
              </span>
              <div className="list">
                <Select
                  options={this.monthOptions}
                  value={selectedOption.value}
                  onChange={this.handleChange}
                  id="startingMonthSelect"
                />
              </div>
            </>
          )}
        </div>
      </div>
    );
  }

  handleChange(value) {
    this.props.onChange(parseInt(value, 10));
  }
}

CalendarStartDateSelector.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  isClient: PropTypes.bool.isRequired,
};
